import { IconButton, Button, Box } from '@mui/material'
import UploadFileIcon from '@mui/icons-material/UploadFile'
import {
  UploadText,
  UploadArea,
  UploadTextArea,
  ImageDropZone,
  Input,
} from './ContainerImagesEditModalFileUpload.styles'
import { useRef, useCallback } from 'react'
import { useDropzone } from 'react-dropzone'

export const ContainerImagesEditModalFileUpload: React.FC<{
  filesToUpload: File[]
  labelText: string
  buttonText: string
  uploadFile: (files: File[]) => void
  onChangeInputFile: (e: React.ChangeEvent<HTMLInputElement>) => void
}> = ({ filesToUpload, buttonText, labelText, uploadFile, onChangeInputFile }): JSX.Element => {
  const inputFile = useRef<any>(null)
  const onDrop = useCallback(
    (acceptedFiles) => {
      // Do something with the files
      if (acceptedFiles.length > 0) {
        const files: File[] = Array.from(acceptedFiles)
        if (filesToUpload.length > 0) {
          uploadFile([...filesToUpload, ...files])
        } else {
          uploadFile(files)
        }
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [filesToUpload]
  )
  const { getRootProps, getInputProps, isDragActive } = useDropzone({ onDrop })
  /**
   * handleUploadBtnClick
   */
  const handleUploadBtnClick = () => {
    inputFile.current?.click()
  }

  return (
    <UploadArea {...getRootProps()}>
      <IconButton
        aria-label="upload picture"
        sx={{ width: '70px', height: '70px' }}
        onClick={handleUploadBtnClick}
      >
        <UploadFileIcon sx={{ width: '50px', height: '50px' }} />
      </IconButton>
      <UploadTextArea>
        <UploadText variant={'body1'}>{labelText}&nbsp;</UploadText>
        <Button
          size={'small'}
          variant={'outlined'}
          sx={{ marginLeft: '8px', width: '131px', height: '28px', textTransform: 'none' }}
        >
          {buttonText}
        </Button>
        <Input
          sx={{
            position: 'absolute',
            top: 0,
          }}
          id="icon-button-file"
          type="file"
          multiple
          onChange={onChangeInputFile}
          {...getInputProps()}
        />
        {isDragActive && <Box sx={ImageDropZone}>Drop Your Files Here</Box>}
      </UploadTextArea>
    </UploadArea>
  )
}
